// ======================================================================
// File Name       : UserHistoryCourseAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { RETURN_MAX_NUM, RETURN_MAX_NUM_1000, SELECT_TARGET_DATA } from '../constants/index';
import { convertObjectToList } from '../utils/UserUtils';
import * as ActionCreator from './actionCreators/userHistoryCourse';
import { getUsersData, setUseTemplateData } from './EmailAction';
import { fetchGroupStructure } from './GroupAction';
import * as courseRequest from './httpRequests/course';
import * as groupRequest from './httpRequests/group';
import * as httpRequests from './httpRequests/userHistoryCourse';
import * as UserActions from './UserAction';

export function initSearchInput(initData) {
  return (dispatch) => {
    dispatch(ActionCreator.doInitSearchInput(initData));
  };
}

export function searchUserHistoryCourse(params) {
  return dispatch => courseRequest.postCourseGetList(params)
    .then((result) => {
      const { recordNum } = result;
      const courseIdList = [];
      const searchResult = [];
      const listLength = result.courseList ? result.courseList.length : 0;
      for (let i = 0; i < listLength; i++) {
        courseIdList.push(result.courseList[i].courseSecernId);
        const item = {
          courseSecernId: result.courseList[i].courseSecernId,
          courseName: result.courseList[i].courseName,
          totalItem: result.courseList[i].itemListForCourseEnd ?
          result.courseList[i].itemListForCourseEnd.length : 0,
          endConditionTypeForCourse: result.courseList[i].endConditionTypeForCourse, // #7436
        };
        searchResult.push(item);
      }
      if (listLength > 0) {
        const searchData = {
          searchInfo: {
            courseList: courseIdList,
            startPosition: 0,
            returnMaxNum: 1000,
          },
        };
        return httpRequests.postEachCourseStatusCount(searchData).then(({ courseStatusList }) => {
          let eachCourseStatusCount = {};
          if (courseStatusList) {
            eachCourseStatusCount = courseStatusList.reduce((acc, cur) => {
              if (cur && cur.courseSecernId) {
                acc[cur.courseSecernId] = cur;
              }
              return acc;
            }, eachCourseStatusCount);
          }
          dispatch(ActionCreator.doReceivedSearchResult(searchResult, eachCourseStatusCount, recordNum));
        });
      }
      dispatch(ActionCreator.doReceivedSearchResult([], {}, recordNum));
    });
}

// #7386 START
export function getBarChartData(params) {
  return async (dispatch, getState) => {
    let courseCompletionSummaryList = {};
    await httpRequests.postEachCourseCompletionStatusSummary(params).then((rs) => {
      if (rs && rs.courseCompletionSummaryList) {
        courseCompletionSummaryList = rs.courseCompletionSummaryList.reduce((acc, cur) => {
          if (cur && cur.completionDay) {
            acc[cur.completionDay] = cur;
          }
          return acc;
        }, courseCompletionSummaryList);
      }
    });
    dispatch(ActionCreator.doReceivedBarChartData(courseCompletionSummaryList));
  };
}
// #7386 END

export function getUserHistoryCourseDetail(courseId, searchCondition) {
  return async (dispatch, getState) => {
    const params = {};
    let courseStatus = {};
    if (getState().userHistoryCourse && getState().userHistoryCourse.courseStatus) {
      courseStatus = getState().userHistoryCourse.courseStatus;
    }
    params.searchInfo = {
      courseList: [courseId],
      courseStatusSortType: searchCondition.courseStatusSortType || 0,
      ascendingDescendingSort: searchCondition.ascendingDescendingSort || 0,
      startPosition: 0,
    };
    params.selectTargetData = SELECT_TARGET_DATA.DATA;
    if (!courseStatus[courseId]) {
      await httpRequests.postEachCourseStatusCount(params).then((rs) => {
        let eachCourseStatusCount = {};
        if (rs && rs.courseStatusList) {
          eachCourseStatusCount = rs.courseStatusList.reduce((acc, cur) => {
            if (cur && cur.courseSecernId) {
              acc[cur.courseSecernId] = cur;
            }
            return acc;
          }, eachCourseStatusCount);
        }
        courseStatus = eachCourseStatusCount;
      });
    }

    // #7386 START
    let endConditionAchievementUserCount = 0;
    let notImplementedUserCount = 0;
    let inProgressUserCount = 0;
    if (courseStatus[courseId]) {
      endConditionAchievementUserCount = courseStatus[courseId].endConditionAchievementUserCount;
      notImplementedUserCount = courseStatus[courseId].notImplementedUserCount;
      inProgressUserCount = courseStatus[courseId].inProgressUserCount;
    }

    const pieChartData = {
      endConditionAchievementUserCount,
      notImplementedUserCount,
      inProgressUserCount,
    };
    dispatch(ActionCreator.doReceivedPieChartData(pieChartData));

    let courseCompletionSummaryList = {};
    const eachCourseCompletionStatusSummaryParams = {
      courseSecernId: courseId,
    };
    await httpRequests.postEachCourseCompletionStatusSummary(eachCourseCompletionStatusSummaryParams).then((rs) => {
      if (rs && rs.courseCompletionSummaryList) {
        courseCompletionSummaryList = rs.courseCompletionSummaryList.reduce((acc, cur) => {
          if (cur && cur.completionDay) {
            acc[cur.completionDay] = cur;
          }
          return acc;
        }, courseCompletionSummaryList);
      }
    });
    dispatch(ActionCreator.doReceivedBarChartData(courseCompletionSummaryList));
    // #7386 END

    courseRequest.postCourseGetList(params).then((result) => {
      const index = result.courseList.findIndex(item => item.courseSecernId === courseId);
      if (result.recordNum <= 0 || index < 0) {
        dispatch(ActionCreator.doReceivedUserHistoryCourseDetail(false, {}, {}));
      } else {
        params.searchInfo.returnMaxNum = RETURN_MAX_NUM;
        params.searchInfo.currentCourseRelationStatus = 1;

        if (searchCondition && searchCondition.startPosition) {
          params.searchInfo.startPosition = searchCondition.startPosition;
        }
        httpRequests.postUserCourseHistoryStatus(params).then((response) => {
          const { courseStatusList } = response;
          const courseDetail = {
            courseSecernId: result.courseList[0].courseSecernId,
            courseName: result.courseList[0].courseName,
            totalItem: courseStatus && courseStatus[courseId] && courseStatus[courseId].itemCount ?
            courseStatus[courseId].itemCount : 0,
            courseCompletitionStatus: courseStatus && courseStatus[courseId]
              ? (`${courseStatus[courseId].endConditionAchievementUserCount}/${response.recordNum}`)
              : '0/0',
            userList: [],
            endConditionTypeForCourse: result.courseList[0].endConditionTypeForCourse, // #6759
          };
          courseDetail.recordNum = response.recordNum;
          if (courseStatusList && courseStatusList.length) {
            const { structures } = getState().group;
            const { bySecernId } = structures;
            if (Object.keys(bySecernId).length <= 0) {
              dispatch(fetchGroupStructure());
            }
            dispatch(getPagingHistoryCourseDetail(courseDetail, searchCondition, response));
          } else {
            dispatch(getPagingHistoryCourseDetail(courseDetail, searchCondition, response));
          }
        });
      }
    });
  };
}

export function getPagingHistoryCourseDetail(courseDetail, searchCondition, response) {
  return (dispatch, getState) => {
    const param = {};
    param.searchInfo = {
      courseList: [courseDetail.courseSecernId],
      currentCourseRelationStatus: 1,
      courseStatusSortType: searchCondition.courseStatusSortType || 0,
      ascendingDescendingSort: searchCondition.ascendingDescendingSort || 0,
      startPosition: searchCondition.startPosition || 0,
      returnMaxNum: RETURN_MAX_NUM,
    };
    if (response === null) {
      httpRequests.postUserCourseHistoryStatus(param).then((result) => {
        dispatch(prepareUserHistoryCourseTableData(result, courseDetail));
      });
    } else {
      dispatch(prepareUserHistoryCourseTableData(response, courseDetail));
    }
  };
}

export function prepareUserHistoryCourseTableData(result, courseDetail) {
  return (dispatch) => {
    const userList = [];
    const dataList = [];
    const listLength = result.courseStatusList.length;
    for (let i = 0; i < listLength; i++) {
      if (result.courseStatusList[i].courseSecernId === courseDetail.courseSecernId) {
        userList.push(result.courseStatusList[i].userSecernId);
        dataList.push(result.courseStatusList[i]);
      }
    }
    courseDetail.userList = dataList;
    const searchData = {
      searchInfo: {
        userList,
        startPosition: 0,
        returnMaxNum: 1000,
      },
    };
    if (userList && userList.length) {
      groupRequest.postUserGroupRelationGetList(searchData).then(({ groupRelationList }) => {
        const userGroupBySecernId = convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
        dispatch(UserActions.searchUserName({ userSecernIdList: userList }));
        dispatch(ActionCreator.doReceivedUserHistoryCourseDetail(true, courseDetail, userGroupBySecernId));
      });
    } else {
      courseDetail.recordNum = 0;
      courseDetail.userList = [];
      dispatch(ActionCreator.doReceivedUserHistoryCourseDetail(true, courseDetail));
    }
  };
}

export function setUserHistoryCourseInitData(isExist) {
  return (dispatch) => {
    dispatch(ActionCreator.doReceivedUserHistoryCourseDetail(isExist, {}, {}));
  };
}

export function getAllUserToSendMail(courseDetail) {
  const { courseSecernId } = courseDetail;
  return (dispatch) => {
    let position = 0;
    const request = [];
    const params = {
      searchInfo: {
        courseList: [courseSecernId],
        courseStatus: 0,
        currentCourseRelationStatus: 1,
        startPosition: position,
        returnMaxNum: RETURN_MAX_NUM_1000,
      },
    };
    dispatch(setUseTemplateData(courseDetail));
    httpRequests.postUserCourseHistoryStatus(params).then((result) => {
      if (result && result.recordNum) {
        let { courseStatusList } = result;
        if (courseStatusList && courseStatusList.length) {
          const userSecernIdList = courseStatusList.map(({ userSecernId }) => userSecernId);
          request.push(dispatch(getUsersData(userSecernIdList)));
        }
        let pager = Math.ceil(result.recordNum / RETURN_MAX_NUM_1000) - 1;
        while (pager > 0) {
          pager--;
          position += RETURN_MAX_NUM_1000;
          params.searchInfo.startPosition = position;

          httpRequests.postUserCourseHistoryStatus(params).then((res) => {
            courseStatusList = res.courseStatusList;
            if (courseStatusList && courseStatusList.length) {
              const userSecernIdList = courseStatusList.map(({ userSecernId }) => userSecernId);
              request.push(dispatch(getUsersData(userSecernIdList)));
            }
          });
        }
      }
    });
    return Promise.all(request);
  };
}
